var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"iframe",staticClass:"sc-message--location",style:(_vm.colors[_vm.message.direction || 'received'])},[(_vm.isSeen)?_c('iframe',{staticClass:"sc-message-map",attrs:{"loading":"lazy","frameborder":"0","scrolling":"no","marginheight":"0","marginwidth":"0","src":_vm.openStreetMapUrl}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }